<template>
  <li class="list__item" @mouseenter="(e) => (hasTooltip ? onMouseEnter(e) : null)">
    <div class="list__item-text">
      <p class="list__item-group-header">
        {{ header }}
      </p>
      <span v-if="subheader" class="list__item-group-subheader">{{ subheader }}</span>
    </div>
    <div v-if="icon || imgSource" class="list__item-icon">
      <component :is="icon" v-if="icon"></component>
      <img v-if="imgSource" :src="imgSource" alt="" />
    </div>
  </li>
</template>
<script lang="ts" setup>
import { toRefs } from 'vue'

const props = defineProps({
  header: {
    type: String,
    required: true
  },
  subheader: {
    type: String,
    required: false,
    default: ''
  },
  icon: {
    type: Object,
    required: false,
    default: () => {}
  },
  imgSource: {
    type: String,
    required: false,
    default: ''
  },
  hasTooltip: {
    type: Boolean,
    default: false
  }
})
const { header, subheader, icon, imgSource } = toRefs(props)
interface EMITS {
  (e: 'longItemText', event: MouseEvent, header?: string, subheader?: string): void
}
const emits = defineEmits<EMITS>()
function onMouseEnter(e) {
  const headerEl = e.currentTarget.firstElementChild?.firstElementChild
  const subheaderEl = e.currentTarget.firstElementChild?.lastElementChild
  if (
    headerEl.clientWidth < headerEl.scrollWidth &&
    subheaderEl.clientHeight < subheaderEl.scrollHeight
  )
    emits('longItemText', e, header.value, subheader.value)
  else if (headerEl.clientWidth < headerEl.scrollWidth) {
    emits('longItemText', e, header.value)
  } else if (subheaderEl.clientHeight < subheaderEl.scrollHeight)
    emits('longItemText', e, subheader.value)
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.list__item {
  color: variables.$color-text-primary;
  column-gap: variables.$gap-small;
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr;
  list-style-type: none;
  margin-right: variables.$margin-medium;
  position: relative;

  &-group {
    grid-column: 1;
    &-header {
      color: variables.$color-text-primary;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      @include font-mixins.desktop-regular-paragraph;
    }
    &-subheader {
      color: variables.$color-text-secondary;
      display: -webkit-inline-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      @include font-mixins.desktop-bold-label;
    }
  }
  &-text {
    overflow: hidden;
  }
  &-icon {
    grid-column: 2;
    justify-self: end;
    width: variables.$icon-medium;
    img {
      width: 100%;
    }
  }
}
</style>
